export function setFlowExecutionId(flowExecutionId: string): BaseTockAction {
  return {
    type: 'SET_FLOW_EXECUTION_ID',
    payload: flowExecutionId,
  };
}
